import { MapConnectSettings } from '../mapConnectSettings';

export const INITIAL_CONNECTIVITY_SETTINGS = MapConnectSettings.ConnectedInRealTime;

export enum LayeredMapModalSection {
  Name = 0,
  ConnectivitySettings = 1,
  MapsSelection = 2,
  MatchUp = 3,
}
